import { EntityDescriptor } from '../business-logic';
import { userSchema } from '../schemas/user';

/** TODO perhaps not used */
export const userEntity: EntityDescriptor = {
	user: {
		migrationStrategies: {
			1: function (oldDoc: any) {
				return oldDoc;
			},
			2: function (oldDoc: any) {
				return oldDoc;
			},
		},
		schema: userSchema,
	},
};
